const state = {
  isSurgicalViewChange: false,
  isInputFormChange: false,
  isHistoryFormChange: false,
};

const getters = {
  getIsSurgicalViewChange: (state) => state.isSurgicalViewChange,
  getInputFormChange: (state) => state.isInputFormChange,
  getHistoryFormChange: (state) => state.isHistoryFormChange,
};

const mutations = {
  setIsSurgicalViewChange(state, payload) {
    state.isSurgicalViewChange = payload;
  },
  setInputFormChange(state, payload) {
    console.log('trigger it', state, payload);
    state.isInputFormChange = payload;
  },
  setHistoryFormChange(state, payload) {
    state.isHistoryFormChange = payload;
  },
  resetState(state) {
    state.isSurgicalViewChange = false;
  },
};

export default {
  state,
  getters,
  mutations,
};
